import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useTabsStyles } from "./chunk-ZWUY3VWT.mjs";
import { useTab } from "./chunk-ROBISDLO.mjs";

// src/tab.tsx
import { cx } from "@chakra-ui/shared-utils";
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Tab = forwardRef(function Tab2(props, ref) {
  var styles = useTabsStyles();
  var tabProps = useTab(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  var tabStyles = _objectSpread({
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, styles.tab);
  return /* @__PURE__ */jsx(chakra.button, _objectSpread(_objectSpread({}, tabProps), {}, {
    className: cx("chakra-tabs__tab", props.className),
    __css: tabStyles
  }));
});
Tab.displayName = "Tab";
export { Tab };